interface LangData {
  id?: number;
  name?: string;
  code?: string;
}
export class Lang {
  public static readonly ID_EN: number = 1;
  public static readonly ID_FR: number = 2;
  public static readonly ID_DEFAULT: number = 2;

  public static getNonTranslatableFields(): string[] { return ['id', 'name', 'code']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'name', 'code']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  name?: string;
  code?: string;

  public static fromAPI(data: LangData): Lang {
    return new Lang(data);
  }

  public static fromAPIArray(data: LangData[]): Lang[] {
    return data.map((item) => Lang.fromAPI(item));
  }

  constructor({id, name, code} : LangData) {
    this.id = id;
    this.name = name;
    this.code = code;
  }

  public toJson(): LangData {
    return {
      id: this.id,
      name: this.name,
      code: this.code
    };
  }
}
